export default __webpack_public_path__ + "static/media/cancel-icon.0a6ec144.svg";